import React from "react";

import {
  Text,
  TextureRect,
  ColorRect,
  ActivableLink,
  VBox,
  Image,
  MarginContainer,
  HBox,
} from "@liro_u/react-components";
import { SideMove } from "@liro_u/react-animation-components";

import { routes } from "@liro_u/cms-front";
import { handleProp } from "@liro_u/cms-front";

import { useLanguageContext } from "@liro_u/cms-front";

const ArticlePreview = ({
  description = "default description here",
  name = "default title",
  image = {
    editorType: "imageSelector",
    value:
      "https://firebasestorage.googleapis.com/v0/b/liro-u.appspot.com/o/GUI%2Fplaceholder%2Fplaceholder.png?alt=media&token=499319ad-3327-4f5c-84cb-b44027484cfe",
    title: "placeholder.png",
  },
  _id = "",
  style,
}) => {
  const { language } = useLanguageContext();

  const getImageProp = () => {
    const acc = {};
    handleProp(image, acc, "image", { language });
    return acc.image;
  };

  return (
    <ActivableLink
      to={routes.page + "/" + _id}
      disabled={!_id}
      style={{ position: "relative", ...style }}
    >
      <TextureRect
        texture={typeof image === "string" ? image : getImageProp()}
        style={{ width: "100%", height: "100%" }}
      >
        <ColorRect
          backgroundColor="#392252"
          style={{
            position: "absolute",
            bottom: "0",
            width: "100%",
            height: "60px",
          }}
        >
          <div
            style={{
              alignItems: "center",
              display: "flex",
              width: "100%",
              height: "100%",
            }}
          >
            <MarginContainer marginLeft={"10px"} marginRight={"10px"}>
              <Text
                fontSize="medium"
                fontWeight="bold"
                text={name}
                textOverflow="ellipsis"
                style={{
                  textAlign: "left",
                  overflow: "hidden",
                  display: "-webkit-box",
                  webkitBoxOrient: "vertical",
                  webkitLineClamp: "2",
                }}
              />
            </MarginContainer>
          </div>
        </ColorRect>
        <SideMove
          translateXStart="0"
          translateXEnd="0"
          translateYStart="100%"
          translateYEnd="0"
          movableBoxStyle={{ width: "100%", height: "100%" }}
          mainBoxStyle={{ width: "100%", height: "100%" }}
          invisibleBoxStyle={{ width: "100%", height: "100%" }}
          mode="onHover"
        >
          <ColorRect
            backgroundColor="#392252"
            style={{
              position: "absolute",
              bottom: "0",
              width: "100%",
              height: "100%",
            }}
          >
            <MarginContainer
              margin={"30px"}
              style={{
                width: "calc(100% - 60px)",
                height: "calc(100% - 60px)",
              }}
            >
              <VBox justifyContent="space-between">
                <Text
                  fontSize="medium"
                  fontWeight="bold"
                  text={description}
                  textOverflow="hidden"
                  style={{
                    width: "100%",
                    height: "100%",
                    textAlign: "left",
                    overflow: "auto",
                    flexGrow: "1",
                  }}
                />
                <HBox justifyContent="right">
                  <Image
                    src="https://firebasestorage.googleapis.com/v0/b/liro-u.appspot.com/o/GUI%2FCarousel%2FShowMore%2FarrowSeeMore.png?alt=media&token=c40602bf-57ad-4f06-bf8b-7c7718f7fef6"
                    width="150px"
                    height="100%"
                  />
                </HBox>
              </VBox>
            </MarginContainer>
          </ColorRect>
        </SideMove>
      </TextureRect>
    </ActivableLink>
  );
};

export default ArticlePreview;
